<template>
  <v-container>
    <h2 class="mb-3">Dashboard</h2>
    <v-card>
      <v-tabs background-color="white" color="primary" left @change="changeActiveTab($event)" ref="tabs">
        <v-tab>Total User Active</v-tab>
        <v-tab>Total Client Active</v-tab>
        <v-tab-item>
          <v-container fluid class="pa-0">
            <Chart v-if="tabActive == 0" v-bind:label="label[0]"></Chart>
          </v-container>
        </v-tab-item>
        <v-tab-item>
          <v-container fluid class="pa-0">
            <Chart v-if="tabActive == 1" v-bind:label="label[1]"></Chart>
          </v-container>
        </v-tab-item>
      </v-tabs>
    </v-card>
  </v-container>
</template>

<script>
import Chart from "./components/Chart";
export default {
  name: "Dashboards",
  data() {
    return {
      label: [
        'total_user_active',
        'total_client_active'
      ],
      tabActive: 0,
    };
  },
  methods: {
    changeActiveTab(e) {
      this.tabActive = e
    },
  },
  components: {
    Chart,
  },
};
</script>
